import React, { useState, useEffect, useRef } from 'react'
import { errorMap } from './BaseComponent'
import Select from 'react-select';

export default function NewSingleSelectComponent({ API, select, selected, endpoint, table, category, turbo = false, disabled }) {
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(false)

    const useDebounce = (callback, delay) => {
      const timeoutRef = useRef(null);
    
      useEffect(() => {
        return () => {
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
        };
      }, []);
    
      const debouncedCallback = (...args) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
    
        timeoutRef.current = setTimeout(() => {
          callback(...args);
        }, delay);
      };
    
      return debouncedCallback;
    };

    const delaySearchCallback = useDebounce((term) => {
      getOptions(term)
    }, 500);
  
    const getOptions = (search) => {
      setLoading(true)
      let url = API+endpoint
      const params = {
        "limit": 20,
        "offset": 0,
        // archived: false,
        orderBy: "created-desc",
        query: search || ""
      }
  
      fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "Authorization": "Bearer " + sessionStorage.getItem('token')
          },
          body: JSON.stringify(params)
        })
      .then((response) => {
          return response.json()
      })
      .then((result) => {
        if (result.status.success) {
            let tempArray = []
            for (let i = 0; i < result.data[table].length; i++) {
                const element = result.data[table][i];
                tempArray.push(element)
                
            }
          setOptions(tempArray)
        } else {
          window.dispatchEvent(new CustomEvent("NOTIFY", { 'detail': {'type': "red", 'content' : errorMap(result.data?.error?.ident || result.data?.error) }}), true);
        }
        setLoading(false)
      }, (error) => {
        console.log(error)
        setLoading(false)
      })
      return options
    }
  
    useEffect(() => {
      getOptions()

      if(document.querySelector(`#${table}_input`)) {
        document.querySelector(`#${table}_input`).addEventListener("blur", () => { getOptions() })
      }
      // eslint-disable-next-line
    }, [])

    const onChange = (selectedOptions) => {
      console.log(selectedOptions)
      select(selectedOptions?.ident || selectedOptions);
    }

    const parsedSelected = typeof selected === "string" ? [selected] : selected
    
    return (
      // <Multiselect
      //   options={options}
      //   selectedValues={parsedSelected}
      //   onSelect={select}
      //   onSearch={(val) => { delaySearchCallback(val) }}
      //   keepSearchTerm={true}
      //   onRemove={select}
      //   isObject={false}
      //   loading={loading}
      //   loadingMessage={"Loading..."}
      //   // singleSelect={true}
      //   selectionLimit={1}
      //   disable={disabled}
      //   id={table}
      // />
      <Select
        className="basic-single"
        classNamePrefix="select"
        isDisabled={disabled}
        isLoading={loading}
        isClearable={true}
        isSearchable={true}
        options={options}
        value={{ident: selected}}
        getOptionLabel={option => option.ident}
        getOptionValue={option => option.ident}
        onChange={onChange}
        onInputChange={(val) => { delaySearchCallback(val) }}
      />
    )
  }